import { DISPATCH_TYPE } from "../utils/enums.js";
import {
  IClientType,
  ICombinationAll,
  IFAQ,
  IFAQFile,
  IKeyword,
  IQuestionType,
  ISection,
  IUser
} from "@/types/SPTypes.tsx";
import {
  setFAQDataActionType,
  setSectionsActionType,
  setQuestionTypesActionType,
  setClientTypesActionType,
  setKeywordsActionType,
  setCombinationsActionType,
  setCurrentUserActionType,
  setCurrentUserEmailActionType,
  setIsLoadingActionType,
  setIsLoggedInActionType,
  setFAQFilesActionType
} from "@/actionTypes/generalActionTypes.ts";

export const setFAQDataAction = (IFAQs: IFAQ[]): setFAQDataActionType => ({
  type: DISPATCH_TYPE.SET_FAQ_DATA,
  payload: IFAQs
});

export const setFAQFilesAction = (
  IFAQFiles: IFAQFile[]
): setFAQFilesActionType => ({
  type: DISPATCH_TYPE.SET_FAQ_FILES,
  payload: IFAQFiles
});

export const setSectionsAction = (
  ISections: ISection[]
): setSectionsActionType => ({
  type: DISPATCH_TYPE.SET_SECTIONS,
  payload: ISections
});

export const setQuestionTypesAction = (
  IQuestionTypes: IQuestionType[]
): setQuestionTypesActionType => ({
  type: DISPATCH_TYPE.SET_QUESTION_TYPES,
  payload: IQuestionTypes
});

export const setClientTypesAction = (
  IClientTypes: IClientType[]
): setClientTypesActionType => ({
  type: DISPATCH_TYPE.SET_CLIENT_TYPES,
  payload: IClientTypes
});

export const setKeywordsAction = (
  IKeywords: IKeyword[]
): setKeywordsActionType => ({
  type: DISPATCH_TYPE.SET_KEYWORDS,
  payload: IKeywords
});

export const setCombinationsAction = (
  ICombinationAlls: ICombinationAll[]
): setCombinationsActionType => ({
  type: DISPATCH_TYPE.SET_COMBINATIONS,
  payload: ICombinationAlls
});

export const setCurrentUserAction = (
  user: IUser | null
): setCurrentUserActionType => ({
  type: DISPATCH_TYPE.SET_CURRENTUSER,
  payload: user
});

export const setCurrentUserEmailAction = (
  email: string | null
): setCurrentUserEmailActionType => ({
  type: DISPATCH_TYPE.SET_CURRENTUSER_EMAIL,
  payload: email
});

export const setIsLoadingAction = (
  isLoading: boolean
): setIsLoadingActionType => ({
  type: DISPATCH_TYPE.SET_IS_LOADING,
  payload: isLoading
});

export const setIsLoggedInAction = (
  isLoggedInAction: boolean
): setIsLoggedInActionType => ({
  type: DISPATCH_TYPE.SET_IS_LOGP,
  payload: isLoggedInAction
});
